module.exports = __webpack_public_path__ + "static/media/circulWhite.4ede5370.svg";